import React, { useState } from "react";
import { sendMessage } from "../../api";
import contact from "../../assets/contact.jpg";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle, loading, success, error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await sendMessage(formData);
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
      setTimeout(() => setStatus("idle"), 3000);
    } catch (error) {
      console.error(error);
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
    }
  };

  return (
    <div
      className="mx-2 lg:mx-20 mt-1 rounded-3xl min-h-[650px] lg:py-0 flex flex-col justify-center"
      id="contact"
    >
      <div className="py-4 mx-2 lg:mx-20 rounded-3xl flex flex-col gap-6">
        <div className="text-xl text-center flex justify-center items-center">
          <h1
            className="font-Poppins font-medium text-slate-400"
            data-aos="zoom-in"
          >
            CONTACT ME
          </h1>
        </div>

        <div
          className="w-full mx-auto bg-white p-6 md:p-8 rounded-2xl mt-4 flex flex-col lg:flex-row gap-8 items-center"
          data-aos="fade-up"
        >
          {/* Image Left Side (Hidden on Mobile/Tablet) */}
          <div className="hidden lg:flex lg:w-1/2 justify-center items-center">
            <img
              src={contact}
              alt="Get in Touch"
              className="w-full max-w-md object-contain rounded-xl drop-shadow-md hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Form Right Side (Full width on Mobile/Tablet) */}
          <div className="w-full lg:w-1/2">
            <form onSubmit={handleSubmit} className="flex flex-col gap-5">
              <div className="flex flex-col gap-2">
                <label
                  htmlFor="name"
                  className="text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#3aa1ff] transition-all"
                  placeholder="John Doe"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label
                  htmlFor="email"
                  className="text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#3aa1ff] transition-all"
                  placeholder="john@example.com"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label
                  htmlFor="message"
                  className="text-sm font-medium text-gray-700"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#3aa1ff] transition-all resize-none"
                  placeholder="How can I help you?"
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={status === "loading"}
                className="mt-2 w-full bg-[#3aa1ff] hover:bg-[#288ce6] text-white font-Poppins font-medium py-3 px-4 rounded-lg transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {status === "loading" ? "Sending..." : "Send Message"}
              </button>

              {status === "success" && (
                <p className="text-green-600 text-center text-sm font-medium mt-2">
                  Message sent successfully! I'll get back to you soon.
                </p>
              )}
              {status === "error" && (
                <p className="text-red-600 text-center text-sm font-medium mt-2">
                  Failed to send message. Please try again later.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
